import dayjs from "dayjs";

export function uid() {
  return "ev_" + Math.random().toString(16).slice(2) + Date.now().toString(16);
}

export function normalizeEvent(e) {
  return {
    id: e.id,
    title: e.title ?? "(Sin asunto)",
    start: e.start,
    end: e.end,
    calendarId: e.calendarId ?? "cal_main",
    showAs: e.showAs ?? "busy",
    recurring: !!e.recurring,
    canceled: !!e.canceled,
    allDay: !!e.allDay,
    location: e.location ?? "",
    description: e.description ?? "",
    remindMinutes: e.remindMinutes ?? 15,
    teams: !!e.teams,
    isPrivate: !!e.isPrivate,
  };
}

export function buildDayHours() {
  const out = [];
  for (let h = 0; h <= 12; h++) out.push(String(h));
  // puedes extender a 24 si quieres
  return out;
}

// Lunes de la semana que contiene "d". Se calcula a partir de .day()
// (0=domingo..6=sábado, siempre así sin importar el locale activo) en vez
// de .startOf("week"), porque ese método SÍ depende del locale (con "es"
// ya arranca en lunes) y sumarle +1 día duplicaba el corrimiento, dejando
// toda la grilla desalineada un día respecto a la fecha real.
function mondayOf(d) {
  return d.subtract((d.day() + 6) % 7, "day");
}

export function buildWeekDays(cursorDate, workWeek = true) {
  const start = mondayOf(cursorDate);
  const days = [];
  const count = workWeek ? 5 : 7;
  for (let i = 0; i < count; i++) days.push(start.add(i, "day"));
  return days;
}

export function buildMonthMatrix(cursorDate) {
  const monthStart = cursorDate.startOf("month");
  const start = mondayOf(monthStart);
  const end = mondayOf(cursorDate.endOf("month")).add(6, "day"); // domingo

  const days = [];
  let d = start;

  while (d.isBefore(end) || d.isSame(end, "day")) {
    days.push(d);
    d = d.add(1, "day");
  }

  const rows = [];
  for (let i = 0; i < days.length; i += 7) rows.push(days.slice(i, i + 7));
  return rows;
}
